import { Grid } from '@mui/material';
import React from 'react';

const GridFormDouble = ({ children }) => {
  return (
    <Grid item xs={12} sm={12} md={10}>
      <div className="flex flex-wrap">{children}</div>
    </Grid>
  );
};

export default GridFormDouble;
